import React from "react";

import { PromoBar } from "@/components/home/PromoBar";
import { Header } from "@/components/home/Header";
import { Hero } from "@/components/home/Hero";
import { Testimonials } from "@/components/home/Testimonials";
import { Services } from "@/components/home/Services";
import { RecentJobs } from "@/components/home/RecentJobs";
import { ContactForm } from "@/components/home/ContactForm";
import { ServiceArea } from "@/components/home/ServiceArea";
import { About } from "@/components/home/About";
import { LatestPosts } from "@/components/home/LatestPosts";
import { FinalCTA } from "@/components/home/FinalCTA";
import { Footer } from "@/components/home/Footer";

export default function Home() {
  return (
    <div className="font-body text-[#000000]">
      <PromoBar />
      <Header />
      <main>
        <Hero />
        <Testimonials />
        <Services />
        <RecentJobs />
        <ContactForm />
        <ServiceArea />
        <About />
        <LatestPosts />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
